module.exports = __webpack_public_path__ + "media/images/chequera-466aaad1f928e8b05aab0a82201ffee0.svg";